import { has } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { localize } from 'vee-validate'
import { Component, Mixins, Watch } from 'vue-property-decorator'

import { errorNotificationWrapper } from "../../../logic/helpers/NotificationService";
import WindowResizeMixin from '../../../logic/helpers/WindowResizeMixin'
import { MenuItems } from "../NewConfig";
import newProcessConfigMenuItems from '../NewConfig/logic'
import TemplateContext from '../includes/TemplateContext'
import { i18nHelper } from "../includes/logic/i18nHelper";

@Component
export default class PanelLayoutMixin extends Mixins(WindowResizeMixin) {
  isCollapsed = isMobile()

  activeGroup: Array<string> = []

  sidebarItemsValue: MenuItems | null = null

  navbarItemsValue: MenuItems = []

  drawerVisible = false

  showNavbar = true

  lastScrollPosition = 0

  asideItemsLoading = false

  saveCallback: any

  @Watch('windowWidth')
  onWindowWidthChange(): void {
    if (this.$screen.md) {
      if (this.drawerVisible) {
        this.drawerVisible = false
      }
    } else {
      this.isCollapsed = true
    }
  }

  @Watch('$route', { immediate: true })
  onRouteChange(): void {
    Promise.all([ this.sidebarItems(), this.navbarItems() ])
  }

  languageUpdated(language: string) {
    i18nHelper.setLocalStorageLocale(language)

    localize(language)

    this.$store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', true)

    Promise.all([ this.sidebarItems(), this.navbarItems() ])
      .then(() => {
        this.$store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', false)
      })
  }

  @Watch('$store.state.AdminTemplate.sidebarMenuReloadToggle')
  onVal() {
    this.sidebarItems()
  }

  @Watch('$store.state.AdminTemplate.menuDrawerToggle')
  onDrawerChange(state: boolean) {
    this.drawerVisible = state
  }

  get isSaveButtonActive(): boolean {
    return this.$store.state.AdminTemplate.applicationConfig.meta.isSaveButtonVisible
  }

  get asideItems(): MenuItems | null {
    return this.sidebarItemsValue
  }

  set asideItems(value: MenuItems | null) {
    this.sidebarItemsValue = value
  }

  get navItems(): MenuItems {
    return this.navbarItemsValue
  }

  set navItems(value: MenuItems) {
    this.navbarItemsValue = value
  }

  get applicationVersion(): string {
    return this.$store.state.AdminTemplate.applicationConfig.footer?.version
  }

  get getBotLink(): string {
    return this.$store.state.AdminTemplate.applicationConfig.rightScreenButton?.link(this.$i18n.locale)
  }

  get siderBreakpoint(): 'md' | undefined {
    if (isMobile()) {
      return undefined
    }

    return 'md'
  }

  onScroll(): any {
    const currentScrollPosition = window.scrollY || document.documentElement.scrollTop

    if (currentScrollPosition < 0) {
      return
    }
    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
      return
    }

    this.showNavbar = currentScrollPosition < this.lastScrollPosition
    this.lastScrollPosition = currentScrollPosition
  }

  handleTriggerHeaderClick(): void {
    if (!this.$screen.md) {
      this.drawerVisible = !this.drawerVisible
    } else {
      this.isCollapsed = !this.isCollapsed
    }
  }

  sidebarItems() {
    this.asideItemsLoading = true

    return newProcessConfigMenuItems(this, this.$store.state.AdminTemplate.applicationConfig.sidebar)
      .then(({ items, activeDropdownKeys }) => {
        this.asideItems = items
        this.activeGroup = activeDropdownKeys
      })
      .catch((error) => {
        errorNotificationWrapper(this.$t('error').toString(), error)

        this.asideItems = []
      })
      .finally(() => this.asideItemsLoading = false)
  }

  navbarItems() {
    return newProcessConfigMenuItems(this, this.$store.state.AdminTemplate.applicationConfig.navbar)
      .then(({ items }) => {
        this.navItems = items
      })
      .catch((error) => {
        errorNotificationWrapper(this.$t('error').toString(), error)

        this.navItems = []
      })
  }

  onSaveButtonClick(): void {
    const templateContext = new TemplateContext(this.$route)
    // const saveCallback = this.$store.state.AdminTemplate.saveButtonCallback

    if (this.saveCallback !== null && typeof this.saveCallback === 'function') {
      this.saveCallback()
    } else {
      if (has(this.$store.state.AdminTemplate.applicationConfig, 'onSaveButtonClick')) {
        this.$store.state.AdminTemplate.applicationConfig.onSaveButtonClick(templateContext, true)
      }
    }
  }

  updated() {
    // костыль для сохранения модулей в сетке чатов
    if (this.$store.state.AdminTemplate.saveButtonCallback !== null) {
      this.saveCallback = this.$store.state.AdminTemplate.saveButtonCallback
    }
  }

  mounted(): void {
    window.addEventListener('scroll', this.onScroll)
  }

  destroyed(): void {
    window.removeEventListener('scroll', this.onScroll)
  }
}
